import React from "react";
import Container from "../components/Layouts/Container";
import JobMississauga from "../components/Jobs/JobMississauga";

const JobMississaugaPage = () => {
  return (
    <Container>
      <JobMississauga />
    </Container>
  );
};

export default JobMississaugaPage;
